module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-展开置顶贴.65cd2.png";